var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37.596 45.95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.6 19.8c0 14.621-18.8 27.152-18.8 27.152s-18.8-12.534-18.8-27.152a18.8 18.8 0 1 1 37.6 0z",
    fill: "#ffc857"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.798,
    cy: 19.798,
    fill: "#f6f6f4",
    r: 6.266
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin.0f24f3a8.svg";
export { ForwardRef as ReactComponent };